import "./PageNotFound.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/landbook.png";
const PageNotFound = () => {
  return (
    <Fragment>
      <div className="error-body-container">
        <div className="not-found-page">
          <div className="not-found-page-land-book-logo">
            <img src={logo} alt="" />
          </div>

          <div className="not-found-content">
            <h1 className="not-found-title">404</h1>

            <h2 className="not-found-sec-heading">
              Oops! This Page Could Not Be Found
            </h2>
            <p className="not-found-subtitle">
              Sorry but the page you are looking for does not exist, have been
              removed, name changed or is temporarily unavailable
            </p>
            {/* <Link to="/user/dashboard" className="goToButton">Go To Dashboard</Link> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PageNotFound;
